import { Skeleton } from 'antd';
import { PropsWithChildren } from 'react';

interface DetailCardProps {
  title: string | React.ReactNode;
  rightExtra?: React.ReactNode;
  titleDescription?: React.ReactNode;
  loading?: boolean;
}

export const DetailCard = (props: PropsWithChildren<DetailCardProps>) => {
  const { title, children, rightExtra, titleDescription, loading } = props;
  return (
    <div className="bg-[var(--fett-bg-elevated)] rounded p-4 flex flex-col gap-3">
      <div className="flex flex-col">
        <div className="flex items-center justify-between">
          {loading ? (
            <Skeleton.Input active size="small" className="!w-48" />
          ) : (
            <div className="text-[18px] font-medium text-[var(--fett-text-primary)]">{title}</div>
          )}
          {rightExtra && <div>{rightExtra}</div>}
        </div>
        {titleDescription ? titleDescription : null}
      </div>
      {children}
    </div>
  );
};
